import Component from "@ember/component"
import { get } from "@ember/object"
import { inject as service } from "@ember/service"
import config from "../config/environment"
import { PAGE_VISIT } from "../lib/actions/app-state"

export default class RecordPageVisit extends Component {
  @service("dispatcher")
  dispatcher

  didReceiveAttrs() {
    if (config.environment !== "test") {
      let title = get(this, "title")
      let urlObject = new URL(window.location.href)
      let queryParams = {}
      urlObject.searchParams.forEach((v, k) => (queryParams[k] = v))
      get(this, "dispatcher").dispatchAction(PAGE_VISIT, {
        title: `Navigated to ${title}`,
        description: `Navigated to ${title}`,
        context: {
          routeName: title,
          ...queryParams,
        },
      })
    }
  }
}
